<div class="side-menu-toggle">
  <button
    class="side-menu-toggle__button"
    (click)="toggleSideFilterMenuSmallScreen()"
  >
    <span class="side-menu-toggle__button-content">
      <span class="side-menu-toggle__button-filter-text">
        <mat-icon>
          filter_alt
        </mat-icon>

        <span>
          {{ 'TRANS__SEARCH__LIMIT_RESULT' | translate }}
        </span>
      </span>

      <span class="side-menu-toggle__selected-filter">
        @if (searchContainer.path !== 'home') {
          <ng-container>
            @if (searchContainer.totalSelectedFilters === 0) {
              <span>
                (
                <span class="side-menu-toggle__selected-filter-number">
                  1
                </span>

                <span>
                  {{ 'TRANS__SEARCH__HEADER__FILTER_SELECTED' | translate }}
                </span>
                )
              </span>
            }
            @else if (searchContainer.totalSelectedFilters > 0) {
              <span>
                (
                <span class="side-menu-toggle__selected-filter-number">
                  {{searchContainer.totalSelectedFilters + 1}}
                </span>

                <span>
                  {{ 'TRANS__SEARCH__HEADER__FILTER_SELECTED' | translate }}
                </span>
                )
              </span>
            }
          </ng-container>
        }
        @else {
          @if (searchContainer.filtersFacets.filtersChecked === 'notChecked') {
            <ng-container>
              (
              <span>
                {{ 'TRANS__SEARCH__HEADER__NO_FILTER' | translate }}
              </span>
              )
            </ng-container>
          }
        }
      </span>
    </span>

    <span class="side-menu-toggle__selected-focus-name">
      <span class="side-menu-toggle__vertical-line"></span>

      <mat-icon [class.text-blue]="searchContainer.focus.curFocusId">
        visibility
      </mat-icon>

      @if (searchContainer.focus.curFocusId) {
        <span class="side-menu-toggle__selected-focus-name-text">
          {{searchContainer.focus.currentFocusName}}
        </span>
      }
      @else {
        <span class="side-menu-toggle__selected-focus-name-text">
          {{ 'TRANS__FOCUS__INFO_NO_FOCUS_SELECTED' | translate }}
        </span>
      }
    </span>
  </button>
</div>
